import { useAppSelector } from '@casops/store/hooks';
import { LatLngExpression } from 'leaflet';
import { useMemo } from 'react';

interface MapViewData {
  centre: LatLngExpression;
  zoom: number;
}

export const useMapLastPositionData = (): MapViewData => {
  const { centreLat, centreLon, zoom } = useAppSelector(state => state.map);

  return useMemo<MapViewData>(() => {
    const centre: LatLngExpression = [centreLat, centreLon];

    return {
      centre,
      zoom,
    };
  }, [centreLat, centreLon, zoom]);
};
